module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div id=\"dialog\" title=\"")
    ; __append(escapeFn(title))
    ; __append("\" style=\"display: none;\">\r\n    <div class=\"container-fluid\" style=\"font-size:12px; padding-top: 10px;\">\r\n        <div class=\"row\">\r\n              <p>The ")
    ; __append(escapeFn(view))
    ; __append(" was not properly saved in your last session. Two ")
    ; __append(escapeFn(view))
    ; __append(" versions are now available. \r\n              <p>")
    ; __append(escapeFn(message))
    ; __append("</p>\r\n\r\n              ")
    ;  if(messageDiscard !== ""){ 
    ; __append("\r\n                <p>")
    ; __append(escapeFn(messageDiscard))
    ; __append("</p>\r\n            ")
    ; }
    ; __append("\r\n        </div>           \r\n    </div>    \r\n</div>\r\n\r\n")
  }
  return __output;

}